import { useLayoutEffect, useRef, type RefObject } from 'react'

/**
 * Ref с последним значением — для обработчиков, на которые подписываются один
 * раз (кнопки Telegram), но которые должны видеть свежие пропсы.
 * Обновляется в layout-эффекте, а не во время рендера.
 */
export const useLatest = <T>(value: T): RefObject<T> => {
  const ref = useRef(value)

  useLayoutEffect(() => {
    ref.current = value
  })

  return ref
}
